import { gql } from '__generated__';

export default gql(`
  mutation AddLottery($input: AddLotteryInput!) {
    addLottery(input: $input) {
      id
    }
  }
`);
